import { render, staticRenderFns } from "./ModalProofreadQuestion.vue?vue&type=template&id=71ff4bf7&scoped=true&lang=pug&"
import script from "./ModalProofreadQuestion.vue?vue&type=script&lang=ts&"
export * from "./ModalProofreadQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./ModalProofreadQuestion.vue?vue&type=style&index=0&id=71ff4bf7&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff4bf7",
  null
  
)

export default component.exports